import axios from '@/libs/api.request';

export const getDistributionStationList = data => {
    return axios.request({
        url: 'api/accountManagement/distributionStationUserManagement/getDistributionStationList',
        data: data,
        method: 'post'
    });
};